'use client';

import React, { type ReactElement } from 'react';
import { Skeleton } from 'antd';
import LightCard from './components/light-card.component';
import OrderProduct from './components/order-product.component';
import Text from './components/text.component';

export interface SkeletonBuilderProps {
  type: 'light-card' | 'order-product' | 'text' | 'price';
  repeat?: number;
}

function renderSkeleton(type: SkeletonBuilderProps['type']) {
  switch (type) {
    case 'light-card':
      return <LightCard />;
    case 'order-product':
      return <OrderProduct />;
    case 'text':
      return <Text />;
    case 'price':
      return (
        <div className="flex flex-col items-end justify-center gap-y-1">
          <Skeleton paragraph={false} title className="w-24" />
          <Skeleton paragraph={false} title className="w-8" />
        </div>
      );
  }
}

export default function SkeletonBuilder({
  type,
  repeat = 1,
}: SkeletonBuilderProps): ReactElement {
  return (
    <>
      {Array.from({ length: repeat }, (_, index) => (
        <React.Fragment key={`${type}-${index}`}>
          {renderSkeleton(type)}
        </React.Fragment>
      ))}
    </>
  );
}
